import { Component, Input, OnChanges } from '@angular/core';
import { IssuePriorityColor, IssueStatusColor } from 'src/app/view/defects/service/models/defect-view-models';
import { ThemeColor } from '../../enums/theme';
import { ProgressBarConfig } from '../../models/progressBar.model';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnChanges {
  /** used for single bar */
  @Input() color: ThemeColor = 'primary';
  /** used for single bar */
  @Input() value: number = 0;
  /** used for many bars - first color will also define  */
  @Input() bars?: ProgressBarConfig[];
  /** if undefined, first value of 'bars' or value of 'color' will be used */
  /** join - bars will be drawn one after another ; sort - shorter bars will be drawn over longer;  */
  @Input() mode: 'join' | 'sort' = 'join';
  @Input() background!: ThemeColor | IssuePriorityColor | IssueStatusColor;
  @Input() max: number = 100;
  @Input() width: number = 10;

  public displayBars: ProgressBarConfig[] = [];

  constructor() {}

  ngOnChanges(): void {
    if (!this.bars) {
      /** bars undefined */
      this.displayBars = [{ color: this.color, value: this.value }];
      if (!this.background) this.background = this.color;
    } else {
      if (this.mode == 'join') {
        let aggregate = 0;
        this.displayBars = this.bars
          .map((x) => { return { color: x.color, value: (aggregate += x.value) }; })
          .reverse(); // prettier-ignore
      } else {
        this.displayBars = this.bars.sort((a, b) => b.value - a.value);
      }

      if (!this.background) this.background = this.bars[0].color;
    }
  }
}
